import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import goods from './modules/goods';
import payState from './modules/payState';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    goods,
    payState,
  },
});

export default store;
